<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
// import layoutMixin from '@/mixins/layoutMixin';

export default {
  name: 'LayoutHandler',

  // mixins: [ layoutMixin ],

  props: {
    name: { default: '' },
  },

  inject: {
    layoutProvider: {
      default: false,
    },
  },

  created() {
    const isLayoutCallable = typeof this.name === 'function';
    const layout = isLayoutCallable ? this.name() : this.name;

    if (layout && this.layoutProvider?.changeLayout) {
      this.layoutProvider.changeLayout(layout); 
    }
    if (this.layoutProvider?.handleEvents) {
      this.layoutProvider.handleEvents(this.$listeners)
    }
  },
}
</script>

<style lang="scss" scoped>

</style>